import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from 'react-lazyload';
const AboutUs = () => {  
  useEffect(() => {
    document.title = 'About Us - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>About School</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="clearfix">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/about_us.png" className="col-md-4 inner_img float-md-end mb-3 ms-md-3 img-fluid" alt="St. Francis Xavier School"/></LazyLoad>
                    <p>St. Francis Xavier School, Hisar was established in 1991. It is one of the many educational
                    institutions run by the Delhi Province of the Society of the Missionaries of St. Francis Xavier
                    alias Society of Pilar.</p>
                  <p>The Society was founded in Goa way back in 1887. Fr. Bento Martins, an ordinary priest with an
                    extraordinary vision, started this Organization with the aim of spreading Jesus' Gospel of human
                    well being and universal love even beyond the borders of Goa. The school is named after St. Francis
                    Xavier the Apostle of the East, a Jesuit priest of the 15th century, who is also the patron of our
                    missionary society.</p>
                  <p>The Society of Pilar has over three hundred members serving the cause of the Gospel message of
                    justice, freedom and love, in about sixty residential units and institutions spread all over India,
                    and countries abroad.</p>
                  <p>The Province of Delhi is one of the four Provinces of the Society of Pilar created on July 2004,
                    which commits itself to the services of the Society in seven States and two Union Territories of
                    North India. The Pilar Fathers, however, have been working in these areas since 1950. Presently, the
                    Delhi Province runs eight English medium Schools in Punjab and Haryana, besides several Boy's Homes,
                    Dispensaries, and other social welfare projects, especially in the rural areas.</p>
                  <p>The School is ably managed and spearheaded by qualified, enthusiastic and committed members even from
                    Goa and other States. The support and collaboration of the Sisters of the Franciscan Missionaries of
                    Christ the King towards the fast growth of the school cannot be overlooked. Thanks to the untiring
                    efforts of our pioneering members.</p>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default AboutUs;
